import groq from 'groq'

export function articleSetup() {
	return groq`
    {
		date,
        category->{
            name,
            slug
        },
        persons,
        legalDisclaimer,
    }
  `
}
